module.exports = __webpack_public_path__ + "img/red_espn.25d34589.png";